module.exports = __webpack_public_path__ + "static/media/alert.4302d369.png";